export const GOAL_TYPES = {
  BEHAVIOR_REDUCTION: 'behavior_reduction',
  SKILL_ACQUISITION: 'skill_acquisition',
  CAREGIVER: 'caregiver',
} as const;

export const TP_GOAL_DATA_COLLECTION_METHODS = {
  PERCENTAGE: 'PERCENTAGE',
  DURATION: 'DURATION',
  INSTANCES: 'INSTANCES',
  RATE: 'RATE',
} as const;

export const RATE_INTERVAL_UNITS = {
  SECOND: 'seconds',
  MINUTE: 'minutes',
  HOUR: 'hours',
} as const;

export const DURATION_EVENT_UNITS = {
  SECOND: 'SECOND',
  MINUTE: 'MINUTE',
  HOUR: 'HOUR',
} as const;

export const DURATION_UNIT_LABELS = {
  [DURATION_EVENT_UNITS.HOUR]: 'hours',
  [DURATION_EVENT_UNITS.MINUTE]: 'mins.',
  [DURATION_EVENT_UNITS.SECOND]: 'secs.',
} as const;

export const GOAL_TYPE_LABELS = {
  [GOAL_TYPES.BEHAVIOR_REDUCTION]: 'Behavior reduction goal',
  [GOAL_TYPES.SKILL_ACQUISITION]: 'Skill acquisition goal',
  [GOAL_TYPES.CAREGIVER]: 'Parent / Caregiver goal',
} as const;

export const SECONDS_PER_HOUR = 3600;
export const SECONDS_PER_MINUTE = 60;
export const TRIAL_DATE_FORMAT = 'MM/DD/YY';
export const PDF_DATE_FORMAT = 'MM/DD/YY';

export const PDF_PAGE_STYLE = `@page {
    margin: 2cm 0 2cm 0 !important;
    @top-center {
      content: none;
    }
    @bottom-center {
      content: none;
    } }
    @page :first {
        margin-top: 0.5cm !important;
        margin-bottom: 0.5cm !important;
      }
    `;

export const PDF_PAGE_BREAK_STYLE = `
          .page-break {
            page-break-after: always;
          }
        `;
